
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { EntityEtapasEmpresa } from './entity-etapas-empresa.model';

export const EntityEtapasEmpresaAdapter: EntityAdapter<EntityEtapasEmpresa> = createEntityAdapter<EntityEtapasEmpresa>({
  selectId: (model) => model.id,
  sortComparer: (a: EntityEtapasEmpresa, b: EntityEtapasEmpresa): number => b.id.toString().localeCompare(a.id.toString())
});

export interface EntityEtapasEmpresaState extends EntityState<EntityEtapasEmpresa> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null | any;
}

export const initialState: EntityEtapasEmpresaState = EntityEtapasEmpresaAdapter.getInitialState({
  isLoading: false,
  hasAddedSuccess: false,
  error: null
});
